module.exports = __webpack_public_path__ + "media/125.37f2cb3a.mp3";